import { render, staticRenderFns } from "./IcLastlist.vue?vue&type=template&id=c34d98a4&scoped=true"
import script from "./IcLastlist.vue?vue&type=script&lang=js"
export * from "./IcLastlist.vue?vue&type=script&lang=js"
import style0 from "./IcLastlist.vue?vue&type=style&index=0&id=c34d98a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34d98a4",
  null
  
)

export default component.exports